(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name fuel.service:commonFuelService
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .service('CommonFuelService', CommonFuelService);

    //Dummy data
    //TODO detele after integration
    var cityList = [
        {cityCode:"SHJ"},
        {cityCode:"DXB"},
        {cityCode:"CMB"}
    ];

    var statusList = [
        {title:'Active', value: 'ACT'},
        {title:'Inactive', value: 'INA'},
        {title:'All', value: null}
    ];

    function CommonFuelService() {
        var self = this;
        self.model = {
            cityList:null
        };

        self.getCityList = function(){
            return self.model.cityList;
        };
        self.setCityList = function(cityList){
            self.model.cityList = cityList;
        };

        self.getStatusList = function () {
            return statusList;
        };

        self.getDefaultStatus = function () {
            return {
                title:'All', value: null
            }
        }

    }
})();